import { render, staticRenderFns } from "./ExpedienteEntryDescargo.vue?vue&type=template&id=3600de38&scoped=true&"
import script from "./ExpedienteEntryDescargo.vue?vue&type=script&lang=js&"
export * from "./ExpedienteEntryDescargo.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteEntryDescargo.vue?vue&type=style&index=0&id=3600de38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600de38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {
  VCardText,
  VDataTable,
  VDivider,
})
